import React from 'react';
export const AuthorHeader = ()=>{
    
    return (
        <div className={`sub_header`}>
            <div className="cloud"></div>
            <div className="inner">
                <div className="title">
                    <img src={`${process.env.PUBLIC_URL}/static/images/meeting/meeting_logo.png`} alt=""/></div>
                </div>
        </div>
    );
};